export const environment = 'https://vinarstvigertner.cz';
